import { createRoute } from '@tanstack/react-router';
import { tourConfigRoute } from '@/features/dashboard/tourConfig/routes/tourConfigRoutes.ts';
import TourConfigInstallmentsPage from '@/features/dashboard/tourConfig/pages/TourConfigInstallmentsPage.tsx';
import TourConfigInstallmentsPageSkeleton from '@/features/dashboard/tourConfig/components/TourConfigInstallmentsPageSkeleton.tsx';
import { queryClient } from '@/App.tsx';
import { getTourInstallmentsQueryOptions } from '@/features/dashboard/tourConfig/hooks/useGetTourInstallments.ts';
import { getBankAccountsQueryOptions } from '@/features/dashboard/paymentConfig/hooks/useGetBankAccounts.ts';
import { getCashInstructionQueryOptions } from '@/features/dashboard/paymentConfig/hooks/useGetCashInstruction.ts';
import { getTourPriceRangeQueryOptions } from '@/features/dashboard/tourConfig/hooks/useGetTourPriceRange.ts';

export const tourConfigInstallmentsRoute = createRoute({
  getParentRoute: () => tourConfigRoute,
  path: 'installments',
  component: TourConfigInstallmentsPage,
  pendingComponent: TourConfigInstallmentsPageSkeleton,
  loader: async ({ params }) => {
    const { tourId } = params;
    const [, bankAccounts, , priceRanges] = await Promise.all([
      queryClient.prefetchQuery(getTourInstallmentsQueryOptions(tourId)),
      queryClient.ensureQueryData(getBankAccountsQueryOptions()),
      queryClient.ensureQueryData(getCashInstructionQueryOptions()),
      queryClient.ensureQueryData(getTourPriceRangeQueryOptions(tourId)),
    ]);
    return { bankAccounts, priceRanges };
  },
});
